import { render, staticRenderFns } from "./ventasporproveedor.vue?vue&type=template&id=e79398a8"
import script from "./ventasporproveedor.vue?vue&type=script&lang=js"
export * from "./ventasporproveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports